<template>
    <div>
        <p class="alert alert-success lead">Conclusão das Configurações</p>

        <div class="d-flex flex-column">
            <az-submit color="primary btn-lg" @click="concluir()">
                <i class="fas fa-mouse-pointer mr-2"></i>
                Concluir Configuração e Iniciar o Uso do Sistema
            </az-submit>
        </div>
    </div>
</template>

<script>
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            dados: null, 
            retorno: null, 
        };
    },

    components: { 
        AzSubmit,
    },

    methods: { 
        concluir() { 
            this.$util.atualizar(this, { 
                service: 'setup',
                func: 'concluir', 
                toast: true, 
                callback: () => { 
                    this.$router.push({path: '/'});
                    this.$store.commit("setUser", null);
                }
            });
        }
    }
}
</script>